import { ErrorDetails } from "../../ServiceDesk/sdServices/loggingSvc";

interface ErrorWithStack extends Error {
  stack: any;
}

export class exceptionHandler {
  // @ngInject
  constructor($provide: ng.auto.IProvideService) {
    $provide.decorator("$exceptionHandler", function ($delegate: ng.IExceptionHandlerService, $injector: any) {
      return function (exception: ErrorWithStack, cause: string) {
        let loggingService = $injector.get("loggingService"); // loggingService must be injected this way to prevent rootScope circular dependency
        (<ErrorDetails>exception).unhandled = true;
        $delegate(exception, cause);
        loggingService.logException(exception);
      };
    });
  }
}
